import { createAction } from '@reduxjs/toolkit';

export const publishSelected = createAction('integration/publishSelected');

export const attachSelected = createAction('integration/attachSelected');

export const cancel = createAction('integration/cancel');
export const expandRequest = createAction('integration/expandRequest');
export const showPayLanding = createAction('integration/showPayLanding');
